import axios from "axios";

export const updateFactory = async (item, id) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };

    const data = await axios.post(
      `${process.env.REACT_APP_URL}/api/factory-master/update-factory-master?id=${id}`,
      item,
      config
    );
    return data;
  } catch (error) {
    return error?.response?.data;
  }
};
